export default __webpack_public_path__ + "static/media/Sobre Ícone.3611be28.svg";